/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { GitHubRepoSchema } from './gitHubRepoSchema';
import type { GitHubUserSchema } from './gitHubUserSchema';

export interface GitHubProfileSchema {
  user: GitHubUserSchema;
  repos: GitHubRepoSchema[];
}
